import { Feature } from "ol";
import { Geometry } from "ol/geom";
import ReportStrategy from "./report.strategy";

export default class TravelReportStrategy extends ReportStrategy{
    getExtraFeatures(): Promise<Feature<Geometry>[]> {
        throw new Error("Method not implemented.");
    }

}